import React, { useState } from 'react';
import './VerComandos.css';
import Comandos from './Comandos';
import ComandosHistoricos from './ComandosHistoricos';
import { Tab, Tabs } from 'react-bootstrap';

function VerComandos(){
    sessionStorage.setItem("screen","comandos");

    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    return (
        <div className="div-tabs-comandos">
            <Tabs defaultActiveKey="Comandos">
                <Tab eventKey="Comandos" title="Comandos">
                    <Comandos/>
                </Tab>
                <Tab eventKey="Históricos" title="Históricos">
                    <ComandosHistoricos code={code}/>
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerComandos;